module.exports = __webpack_public_path__ + "e049342d87bffff36d9ea41ab7a95cca.png";